import * as React from 'react';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import {none, option} from "ts-option";
import {ValuableProps} from "../../common/props/ValuableProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";

import "./datePickerComponent.scss";

interface ComponentProps {
	/**
	 * Max available date.
	 */
	maxDate?: moment.Moment;
	/**
	 * Min available date.
	 */
	minDate?: moment.Moment;
	/**
	 * Date format.
	 */
	dateFormat?: string | string[];
	/**
	 * Initial date picker date.
	 */
	initialDate?: moment.Moment
	/**
	 * Display inline
	 */
	inline?: boolean
	/**
	 * Custom class for date picker component.
	 */
	customClass?: string;
	/**
	 * Indicates if date picker is disabled
	 */
	disabled?: boolean;
	/**
	 * Indicates if date picker is clearable
	 */
	clearable?: boolean;
	/**
	 * Custom input component
	 * @returns {JSX.Element}
	 */
	customInput?: JSX.Element
}

type Props = ComponentProps & ValuableProps<moment.Moment> & PlaceholderProps

export default class DatePickerComponent extends React.Component<Props, {}> {
	public static defaultProps: Partial<Props> = {
		customClass: ""
	};

	render() {
		return (
			<DatePicker className="c-date-picker-input"
						readOnly={true}
						calendarClassName={`c-date-picker ${this.props.customClass}`}
						fixedHeight={true}
						scrollableYearDropdown={true}
						showYearDropdown={true}
						showMonthDropdown={true}
						yearDropdownItemNumber={10}
						maxDate={this.props.maxDate}
						minDate={this.props.minDate}
						placeholderText={this.props.placeholder}
						openToDate={this.props.value.getOrElse(this.props.initialDate)}
						locale="en-gb"
						selected={!this.props.disabled ? this.props.value.orNull : null}
						onChangeRaw={(a) => this.props.onChange(none)}
						onChange={m => this.props.onChange(option(m))}
						popperClassName={"c-date-picker-popper"}
						dateFormat={this.props.dateFormat}
						inline={this.props.inline}
						disabled={this.props.disabled}
						isClearable={this.props.clearable}
						customInput={this.props.customInput}
			/>
		);
	}
}